export const role = {
  userintervention: "Utilisateur Intervention",
  userasset: "Utilisateur Actif",
  userlocation: "Utilisateur Localisation",
  userorganization: "Utilisateur Organisation",
  adminlocation: "Administrateur Localisation",
  adminorganization: "Administrateur Organisation",
  superadmin: "Super Administrateur",
};
